import React from 'react';

class OnlineChecker extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      online: window.navigator.onLine,
    };

    window.addEventListener('offline', () => this.setState({ online: false }));
    window.addEventListener('online', () => this.setState({ online: true }));
  }

  render() {
    const { online } = this.state;
    return (
      <div>
        { !online &&
          <div className="app-offline-message">
            <p>Oops! You don’t appear to be connected to the internet. Please connect and try again.</p>
          </div>
        }
      </div>
    );
  }
}

export default OnlineChecker;



/** WEBPACK FOOTER **
 ** ./src/containers/online-checker/index.js
 **/